export default __webpack_public_path__ + "static/media/arrow-down-right.591aef0b.svg";